export const leadKeys = {
  all: ['leads'] as const,
  lists: () => [...leadKeys.all, 'list'] as const,
  list: (filters: object) => [...leadKeys.lists(), filters] as const,
  details: () => [...leadKeys.all, 'detail'] as const,
  detail: (id: string) => [...leadKeys.details(), id] as const,
  activities: (id: string) => [...leadKeys.detail(id), 'activities'] as const,
  notes: (id: string) => [...leadKeys.detail(id), 'notes'] as const,
  tasks: (id: string) => [...leadKeys.detail(id), 'tasks'] as const,
};

export const contactKeys = {
  all: ['contacts'] as const,
  lists: () => [...contactKeys.all, 'list'] as const,
  list: (filters: object) => [...contactKeys.lists(), filters] as const,
  details: () => [...contactKeys.all, 'detail'] as const,
  detail: (id: string) => [...contactKeys.details(), id] as const,
  activities: (id: string) => [...contactKeys.detail(id), 'activities'] as const,
  notes: (id: string) => [...contactKeys.detail(id), 'notes'] as const,
  deals: (id: string) => [...contactKeys.detail(id), 'deals'] as const,
  emails: (id: string) => [...contactKeys.detail(id), 'emails'] as const,
  tasks: (id: string) => [...contactKeys.detail(id), 'tasks'] as const,
};

export const companyKeys = {
  all: ['companies'] as const,
  lists: () => [...companyKeys.all, 'list'] as const,
  list: (filters: object) => [...companyKeys.lists(), filters] as const,
  details: () => [...companyKeys.all, 'detail'] as const,
  detail: (id: string) => [...companyKeys.details(), id] as const,
  contacts: (id: string) => [...companyKeys.detail(id), 'contacts'] as const,
  deals: (id: string) => [...companyKeys.detail(id), 'deals'] as const,
  activities: (id: string) => [...companyKeys.detail(id), 'activities'] as const,
  notes: (id: string) => [...companyKeys.detail(id), 'notes'] as const,
};

export const dealKeys = {
  all: ['deals'] as const,
  lists: () => [...dealKeys.all, 'list'] as const,
  list: (filters: object) => [...dealKeys.lists(), filters] as const,
  details: () => [...dealKeys.all, 'detail'] as const,
  detail: (id: string) => [...dealKeys.details(), id] as const,
  pipeline: (pipelineId: string) => [...dealKeys.all, 'pipeline', pipelineId] as const,
  activities: (id: string) => [...dealKeys.detail(id), 'activities'] as const,
  notes: (id: string) => [...dealKeys.detail(id), 'notes'] as const,
  tasks: (id: string) => [...dealKeys.detail(id), 'tasks'] as const,
};

export const pipelineKeys = {
  all: ['pipelines'] as const,
  lists: () => [...pipelineKeys.all, 'list'] as const,
  list: () => [...pipelineKeys.lists()] as const,
  details: () => [...pipelineKeys.all, 'detail'] as const,
  detail: (id: string) => [...pipelineKeys.details(), id] as const,
};

export const taskKeys = {
  all: ['tasks'] as const,
  lists: () => [...taskKeys.all, 'list'] as const,
  list: (filters: object) => [...taskKeys.lists(), filters] as const,
  details: () => [...taskKeys.all, 'detail'] as const,
  detail: (id: string) => [...taskKeys.details(), id] as const,
};

export const activityKeys = {
  all: ['activities'] as const,
  lists: () => [...activityKeys.all, 'list'] as const,
  list: (filters: object) => [...activityKeys.lists(), filters] as const,
  details: () => [...activityKeys.all, 'detail'] as const,
  detail: (id: string) => [...activityKeys.details(), id] as const,
};

export const noteKeys = {
  all: ['notes'] as const,
};

export const emailKeys = {
  all: ['emails'] as const,
  lists: () => [...emailKeys.all, 'list'] as const,
  list: (filters: object) => [...emailKeys.lists(), filters] as const,
  details: () => [...emailKeys.all, 'detail'] as const,
  detail: (id: string) => [...emailKeys.details(), id] as const,
};

export const expenseKeys = {
  all: ['expenses'] as const,
  lists: () => [...expenseKeys.all, 'list'] as const,
  list: (filters: object) => [...expenseKeys.lists(), filters] as const,
  details: () => [...expenseKeys.all, 'detail'] as const,
  detail: (id: string) => [...expenseKeys.details(), id] as const,
  pendingApprovals: () => [...expenseKeys.all, 'pending-approvals'] as const,
  categories: () => [...expenseKeys.all, 'categories'] as const,
};

export const invoiceKeys = {
  all: ['invoices'] as const,
  lists: () => [...invoiceKeys.all, 'list'] as const,
  list: (filters: object) => [...invoiceKeys.lists(), filters] as const,
  details: () => [...invoiceKeys.all, 'detail'] as const,
  detail: (id: string) => [...invoiceKeys.details(), id] as const,
  nextNumber: () => [...invoiceKeys.all, 'next-number'] as const,
};

export const paymentKeys = {
  all: ['payments'] as const,
  lists: () => [...paymentKeys.all, 'list'] as const,
  list: (filters: object) => [...paymentKeys.lists(), filters] as const,
  details: () => [...paymentKeys.all, 'detail'] as const,
  detail: (id: string) => [...paymentKeys.details(), id] as const,
};

export const accountKeys = {
  all: ['accounts'] as const,
  lists: () => [...accountKeys.all, 'list'] as const,
  list: () => [...accountKeys.lists()] as const,
  details: () => [...accountKeys.all, 'detail'] as const,
  detail: (id: string) => [...accountKeys.details(), id] as const,
};

export const transactionKeys = {
  all: ['transactions'] as const,
  lists: () => [...transactionKeys.all, 'list'] as const,
  list: (filters: object) => [...transactionKeys.lists(), filters] as const,
  details: () => [...transactionKeys.all, 'detail'] as const,
  detail: (id: string) => [...transactionKeys.details(), id] as const,
};

export const budgetKeys = {
  all: ['budgets'] as const,
  lists: () => [...budgetKeys.all, 'list'] as const,
  list: () => [...budgetKeys.lists()] as const,
  details: () => [...budgetKeys.all, 'detail'] as const,
  detail: (id: string) => [...budgetKeys.details(), id] as const,
};

export const dashboardKeys = {
  all: ['dashboard'] as const,
  summary: () => [...dashboardKeys.all, 'summary'] as const,
  dealsFunnel: (pipelineId?: string) => [...dashboardKeys.all, 'deals-funnel', pipelineId] as const,
  revenueChart: (params?: object) => [...dashboardKeys.all, 'revenue-chart', params] as const,
  leadSources: () => [...dashboardKeys.all, 'lead-sources'] as const,
  tasksOverview: () => [...dashboardKeys.all, 'tasks-overview'] as const,
  recentActivities: () => [...dashboardKeys.all, 'recent-activities'] as const,
  topDeals: () => [...dashboardKeys.all, 'top-deals'] as const,
};

export const notificationKeys = {
  all: ['notifications'] as const,
  lists: () => [...notificationKeys.all, 'list'] as const,
  list: (filters: object) => [...notificationKeys.lists(), filters] as const,
  unreadCount: () => [...notificationKeys.all, 'unread-count'] as const,
};

export const signatureKeys = {
  all: ['signatures'] as const,
  list: () => [...signatureKeys.all, 'list'] as const,
  detail: (id: string) => [...signatureKeys.all, 'detail', id] as const,
};

export const quotationKeys = {
  all: ['quotations'] as const,
  lists: () => [...quotationKeys.all, 'list'] as const,
  list: (filters: object) => [...quotationKeys.lists(), filters] as const,
  details: () => [...quotationKeys.all, 'detail'] as const,
  detail: (id: string) => [...quotationKeys.details(), id] as const,
  nextNumber: () => [...quotationKeys.all, 'next-number'] as const,
};

export const agreementKeys = {
  all: ['agreements'] as const,
  lists: () => [...agreementKeys.all, 'list'] as const,
  list: (filters: object) => [...agreementKeys.lists(), filters] as const,
  details: () => [...agreementKeys.all, 'detail'] as const,
  detail: (id: string) => [...agreementKeys.details(), id] as const,
  nextNumber: () => [...agreementKeys.all, 'next-number'] as const,
};

export const agreementTemplateKeys = {
  all: ['agreement-templates'] as const,
  lists: () => [...agreementTemplateKeys.all, 'list'] as const,
  list: (filters: object) => [...agreementTemplateKeys.lists(), filters] as const,
  details: () => [...agreementTemplateKeys.all, 'detail'] as const,
  detail: (id: string) => [...agreementTemplateKeys.details(), id] as const,
};

export const organizationSettingsKeys = {
  all: ['organization-settings'] as const,
  current: () => [...organizationSettingsKeys.all, 'current'] as const,
};

export const financialReportKeys = {
  all: ['financial-reports'] as const,
  pnl: (params: object) => [...financialReportKeys.all, 'pnl', params] as const,
  cashFlow: (params: object) => [...financialReportKeys.all, 'cash-flow', params] as const,
  expenseSummary: (params: object) => [...financialReportKeys.all, 'expense-summary', params] as const,
  revenueForecast: (params: object) => [...financialReportKeys.all, 'revenue-forecast', params] as const,
  aging: (params: object) => [...financialReportKeys.all, 'aging', params] as const,
};

export const employeeKeys = {
  all: ['employees'] as const,
  lists: () => [...employeeKeys.all, 'list'] as const,
  list: (filters: object) => [...employeeKeys.lists(), filters] as const,
  details: () => [...employeeKeys.all, 'detail'] as const,
  detail: (id: string) => [...employeeKeys.details(), id] as const,
  nextCode: () => [...employeeKeys.all, 'next-code'] as const,
  structures: (id: string) => [...employeeKeys.detail(id), 'salary-structures'] as const,
};

export const payComponentKeys = {
  all: ['pay-components'] as const,
  lists: () => [...payComponentKeys.all, 'list'] as const,
  list: (includeInactive: boolean) => [...payComponentKeys.lists(), { includeInactive }] as const,
  details: () => [...payComponentKeys.all, 'detail'] as const,
  detail: (id: string) => [...payComponentKeys.details(), id] as const,
};

export const salaryStructureKeys = {
  all: ['salary-structures'] as const,
  details: () => [...salaryStructureKeys.all, 'detail'] as const,
  detail: (id: string) => [...salaryStructureKeys.details(), id] as const,
  breakdown: (id: string) => [...salaryStructureKeys.detail(id), 'breakdown'] as const,
};

export const payslipKeys = {
  all: ['payslips'] as const,
  lists: () => [...payslipKeys.all, 'list'] as const,
  list: (filters: object) => [...payslipKeys.lists(), filters] as const,
  details: () => [...payslipKeys.all, 'detail'] as const,
  detail: (id: string) => [...payslipKeys.details(), id] as const,
  nextNumber: () => [...payslipKeys.all, 'next-number'] as const,
};

export const payrollRunKeys = {
  all: ['payroll-runs'] as const,
  lists: () => [...payrollRunKeys.all, 'list'] as const,
  list: (filters: object) => [...payrollRunKeys.lists(), filters] as const,
  details: () => [...payrollRunKeys.all, 'detail'] as const,
  detail: (id: string) => [...payrollRunKeys.details(), id] as const,
  eligible: (year: number, month: number) => [...payrollRunKeys.all, 'eligible', year, month] as const,
};

export const selfServiceKeys = {
  all: ['me'] as const,
  employee: () => [...selfServiceKeys.all, 'employee'] as const,
  payslips: (filters: object) => [...selfServiceKeys.all, 'payslips', filters] as const,
  payslip: (id: string) => [...selfServiceKeys.all, 'payslip', id] as const,
};
